import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="relative w-full bg-ink-900 py-12 sm:py-16" data-id="element-91">
      <div className="absolute inset-0 bg-radial-cyan-soft opacity-60" aria-hidden="true" data-id="element-92" />
      <div className="relative mx-auto max-w-3xl px-5" data-id="element-93">
        <Reveal data-id="element-94">
          <div className="relative overflow-hidden rounded-[2rem] border border-accent/30 bg-gradient-to-br from-ink-800 to-ink-950 p-8 text-center shadow-card sm:p-12" data-id="element-95">
            <motion.div animate={{
            scale: [1, 1.06, 1]
          }} transition={{
            duration: 3,
            repeat: Infinity
          }} className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-accent/10 ring-1 ring-accent/40" data-id="element-96">
              <ShieldCheckIcon className="h-10 w-10 text-accent" aria-hidden="true" data-id="element-97" />
            </motion.div>

            <span className="mt-6 inline-block rounded-full border border-accent/30 bg-accent/5 px-4 py-1 text-xs font-bold uppercase tracking-widest text-accent-light" data-id="element-98">
              Garantía Anti-Estafas
            </span>

            <h2 className="mt-4 font-display text-3xl uppercase tracking-tight text-chrome sm:text-4xl" data-id="element-99">
              7 días de resultados o tu dinero de vuelta
            </h2>

            <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-silver/80 sm:text-base" data-id="element-100">
              Si en los próximos 7 días no sientes que este sistema te ha
              ahorrado al menos{' '}
              <span className="font-semibold text-white" data-id="element-101">
                20 horas de trabajo
              </span>{' '}
              o no has logrado crear tu primer activo digital con éxito,
              escríbenos. Te devolvemos el{' '}
              <span className="font-semibold text-white" data-id="element-102">
                100% de tu dinero
              </span>{' '}
              y te quedas con el material por las molestias.
            </p>

            <p className="mt-6 font-heading text-lg font-extrabold uppercase tracking-wide text-accent" data-id="element-103">
              El riesgo es nuestro.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}